import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { IInputDistanceProps } from 'components/InputDistance/types'
import { InputNumber } from 'components/InputNumber'
import Heading from 'components/v2/Heading'
import { ValidationWrapper } from 'components/v2/ValidationWrapper'

const StyledInputNumber = styled(InputNumber)`
  width: 160px;
`

const InputContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`

export const InputDistance = ({
  distance,
  setDistance,
  touched,
  errors,
  onBlur,
  disabled
}: IInputDistanceProps): ReactElement => {
  return (
    <ValidationWrapper touched={touched} errors={errors}>
      {(isInvalid): ReactElement => (
        <InputContainer>
          <StyledInputNumber
            value={distance ?? ''}
            onChange={(value: string): void => {
              setDistance(isFinite(parseInt(value)) ? parseInt(value) : '')
            }}
            onBlur={onBlur}
            isInvalid={isInvalid}
            disabled={disabled}
          />
          <Heading.Body>
            <FormattedMessage id="form.distance.unit" defaultMessage="km" />
          </Heading.Body>
        </InputContainer>
      )}
    </ValidationWrapper>
  )
}
